import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledListings = styled('div')`
  background-color: ${({ theme }) => theme.whiteSmoke};

  .filter-order{
    .anticon {
      font-size: 15px;
      width: 20px;
    }
  }
  .listings-filters-container {
    display: flex;
    flex-direction: row;
    column-gap: 50px;

    .ant-spin-nested-loading {
      width: 100%;
    }

    .listings-wrapper {
      width: 100%;

      .listings-grid {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding-top: 40px;
      }

      .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 77px 0 83px 0;

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 0;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          font-family: ${({ theme }) => theme.fontText} !important;
        }
      }
    }
  }

  .ant-pagination-item {
    margin-right: 0;
  }

  .ant-pagination-prev {
    margin-right: 24px;
  }

  .ant-pagination-next {
    margin-left: 24px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .listings-filters-container {
      .listings-wrapper {
        padding-right: 0 !important;
        width: 100%;

        .listings-grid {
          padding-top: 10px;
        }
      }
    }

    .form-container {
      display: none !important;
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .pagination {
      padding: 15px 0 33px 0 !important;
    }
  }
`;

export const StyledListingsFilters = styled('div')`
  margin-top: 40px;
  padding-bottom: 15px;

  .form-title {
    font-weight: 600;
    padding-bottom: 5px;
  }

  .ant-form-item-label {
    font-weight: 600;
  }

  .filter-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 16px;
    color: ${({ theme }) => theme.colorText};
  }

  .category-selector-wrapper,
  .status-checkboxes {
    margin-bottom: 16px;
  }

  .status-checkboxes {
    .filter-label {
      font-weight: 600;
    }

    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .ant-checkbox-wrapper {
        margin-left: 0;
      }
    }
  }

  .ant-form {
    padding-right: 0;

    .location-autocomplete {
      .ant-select-selector {
        background-color: transparent;

        .ant-input-suffix {
          div {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.colorText} !important;
    font-size: 16px;
    line-height: 28px;
  }

  .ant-form-item-control-input-content {
    .ant-select-in-form-item {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      border: 2px solid ${({ theme }) => theme.borderBottom};
    }

    .transaction-select {
      .ant-select-arrow {
        height: 16px;
      }
    }
  }

  .styled-category-selector {
    .ant-form-item {
      border-radius: 5px;
      margin-bottom: 0;
    }
  }

  .ant-form-item {
    border-radius: 5px;
  }

  .ant-select-selector {
    border-radius: 9px;
    background-color: ${({ theme }) => theme.inputBitDarkerOverlay};
    min-height: 45px;
  }

  .ant-select-arrow {
    color: ${({ theme }) => theme.stepArrowColor};
    height: 15px;
  }

  .ant-input,
  .ant-input-affix-wrapper {
    border-radius: 10px;
    border: 2px solid ${({ theme }) => theme.borderBottom};
    background-color: ${({ theme }) => theme.inputBitDarkerOverlay};
    color: ${({ theme }) => theme.colorText};
    min-height: 45px;
  }

  .ant-input-affix-wrapper {
    padding: 0;

    .ant-input {
      border: none;
      background-color: transparent;
      padding-left: 4px;
    }

    .ant-input-suffix {
      background-color: transparent;

      .ant-input-clear-icon {
        padding: 16px;
      }
    }
  }

  .ant-input-number {
    min-height: 45px;
    display: flex;
    align-items: center;
  }

  .ant-input-number-input-wrap {
    display: flex;
    align-items: center;
  }

  .ant-input-number-input {
    color: ${({ theme }) => theme.colorText};
  }

  .ant-input-number-group-wrapper {
    min-height: 45px;
    border-radius: 10px;

    .ant-input-number-group {
      min-height: 45px;
      display: flex;
      border-radius: 10px;
      align-items: center;
      background-color: ${({ theme }) => theme.inputBitDarkerOverlay};
    }

    .ant-input-number {
      min-height: 45px;
      border-radius: 10px 0 0 10px;
      border: 2px ${({ theme }) => theme.borderBottom};
      border-style: solid none solid solid;
    }

    .ant-input-number-group-addon {
      display: flex;
      align-items: center;
      border-radius: 0 10px 10px 0;
      border: 2px ${({ theme }) => theme.borderBottom};
      border-style: solid solid solid none;
      min-height: 45px;
      width: 20%;
    }
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
  .ant-input:hover,
  .ant-input-affix-wrapper:hover,
  .ant-input-number:hover,
  .ant-input-number-group-wrapper:hover {
    border-color: ${({ theme }) => theme.borderBottom};
  }

  .ant-input:focus,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper:focus-within,
  .ant-input-number:focus,
  .ant-input-number:focus-within {
    border-color: ${({ theme }) => theme.borderBottom};
    box-shadow: none;
  }

  .clear-filters-button {
    margin-top: 16px;
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.brand02};
    color: ${({ theme }) => theme.brand02};

    &:hover {
      background-color: ${({ theme }) => theme.brand02};
      color: ${({ theme }) => theme.white};
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    margin-top: 0;
  }
`;

export const StyledListingCard = styled('div')`
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0px 2px 8px ${({ theme }) => theme.boxShadowColor};

  .listing-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .header-left {
      flex: 1;

      .listing-title {
        font-size: 18px;
        font-weight: 600;
        color: ${({ theme }) => theme.colorText};
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 12px;

      .identifier {
        font-size: 15px;
        font-weight: 400;
        color: ${({ theme }) => theme.colorText};
      }
    }
  }

  .listing-description-row {
    display: flex;
    align-items: baseline;
    margin-bottom: 16px;

    .description-label {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.grey};
      flex: 0 0 15%;
    }

    .description-text {
      font-size: 14px;
      color: ${({ theme }) => theme.colorText};
      line-height: 20px;
      flex: 0 0 85%;
    }
  }

  .listing-content {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .edited-row {
      .edited-text {
        font-size: 14px;
        font-style: italic;
        color: ${({ theme }) => theme.grey};
      }
    }

    .products-and-delivery {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      gap: 16px;

      .products-delivery-info {
        flex: 0 0 74%;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .products-row,
        .delivery-row,
        .farm-row {
          display: flex;
          align-items: baseline;
          gap: 2px;

          .products-label,
          .delivery-label,
          .farm-label {
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.grey};
            flex: 0 0 20%;
          }

          .products-text,
          .delivery-text,
          .farm-text {
            font-size: 14px;
            color: ${({ theme }) => theme.colorText};
            line-height: 20px;
            flex: 0 0 77%;
          }
        }
      }

      .button-container {
        display: flex;
        align-items: flex-end;

        button {
          align-self: end;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    padding: 16px;

    > .ant-divider {
      display: none;
    }

    .listing-card-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;

      .header-right {
        width: 100%;
        justify-content: space-between;
      }
    }

    .listing-description-row {
      flex-direction: column;
      gap: 4px;

      .description-label,
      .description-text {
        flex: 1 1 100%;
        font-size: 16px;
      }
    }

    .listing-content {
      gap: 0;
      .products-and-delivery {
        flex-direction: column;
        align-items: stretch;
        gap: 0;

        .products-delivery-info {
          flex: 1 1 100%;
          width: 100%;
          gap: 0;

          .products-row,
          .delivery-row,
          .farm-row {
            flex-direction: column;
            gap: 4px;
            padding: 12px 0;
            border-top: 1px solid ${({ theme }) => theme.borderBottom};

            .products-label,
            .delivery-label,
            .farm-label {
              flex: none;
              font-size: 16px;
            }

            .products-text,
            .delivery-text,
            .farm-text {
              flex: none;
              font-weight: 500;
              font-size: 16px;
            }
          }
        }

        .button-container {
          width: 100%;
          padding-top: 8px;

          button {
            width: 100%;
            background-color: ${({ theme }) => theme.wholesale};
            color: ${({ theme }) => theme.white};
            border-radius: 20px;
            height: 44px;
          }
        }
      }
    }
  }
`;
